import FeeState from "@/models/Accounts/Shared/Fees/FeeState";

export default (val: FeeState) => {
    let returnVal = "Undefined";
    switch (val) {
        case FeeState.Created:
            returnVal = "Created"
            break;
        case FeeState.Pending:
            returnVal = "Pending"
            break;
        case FeeState.Paid:
            returnVal = "Paid"
            break;
        case FeeState.Failed:
            returnVal = "Failed"
            break;
    }
    return returnVal;
}